/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetDisplayNameStatusClientRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_display_name_status_client.pb'
import {GetDisplayNameStatusClientResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_display_name_status_client.pb'


export const getDisplayNameStatusClient = (request: GetDisplayNameStatusClientRequest, options?: CashRequestOptions) => post<GetDisplayNameStatusClientRequest, GetDisplayNameStatusClientResponse>("/2.0/cash/get-display-name-status-client", request, {...options, rejectOnError: true })